(function() {
    'use strict';

    angular.module('montage')
        .controller('MontageListController', MontageListController);

    MontageListController.$inject = [
        '$state',
        '$uibModal',
        'montageDataSrvc',
        'montageSrvc',
        'notificationSrvc',
        'montageMessagesConst',
        'lodashService',
        'datatableDefaultPageSizeValueConst',
        'checkSearchSrvc',
        'searchFilterSrvc',
        'montagePermissionsConst',
        'montageStateOptionsConst',
        'checkModelPermissionsSrvc',
        'filterQuerySrvc',
        'rwStatusesConst',
        'siteDataSrvc'
    ];

    function MontageListController(
        $state,
        $uibModal,
        montageDataSrvc,
        montageSrvc,
        notificationSrvc,
        montageMessagesConst,
        lodashService,
        datatableDefaultPageSizeValueConst,
        checkSearchSrvc,
        searchFilterSrvc,
        montagePermissionsConst,
        montageStateOptionsConst,
        checkModelPermissionsSrvc,
        filterQuerySrvc,
        rwStatusesConst,
        siteDataSrvc
    ) {
        var self = this;

        self.loading = true;
        self.isArchive = isArchive;
        self.title = null;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.montageRows = [];
        self.montageCols = [{
            title: 'Nr montażu',
            value: 'pk',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Nakład netto',
            value: 'quantity_net',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Papier',
            value: 'paper_option',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Format arkusza',
            value: 'sheet_format',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Liczba płyt',
            value: 'plate_quantity',
            type: 'number',
            searchable: true,
            orderable: true
        }, {
            title: 'Arkusz na odwrotkę',
            value: 'flipped',
            type: 'boolean',
            searchable: true,
            orderable: true
        }, {
            title: 'Wartość zleceń netto',
            value: 'products_net_value',
            type: 'decimal'
        }, {
            title: 'Koszt montażu',
            value: 'montage_cost',
            type: 'decimal'
        }, {
            title: 'Koszt naddatku',
            value: 'surplus_cost',
            type: 'decimal'
        }, {
            title: 'Różnica',
            value: 'difference',
            type: 'decimal'
        }, {
            title: 'Procent',
            value: 'percent',
            type: 'decimal'
        }, {
            title: 'Wartość dodatkowa netto',
            value: 'extra_net',
            type: 'decimal',
            searchable: true,
            orderable: true
        }, {
            title: 'Termin',
            value: 'realization_date',
            type: 'date',
            searchable: true,
            orderable: true
        }];
        self.modelPermissions = montagePermissionsConst;

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.summaryCols = {
            'quantity_net': 'quantity_net',
            'quantity_surplus': 'quantity_surplus',
            'extra_net': 'extra_net',
            'products_net_value': 'products_net_value',
            'montage_cost': 'montage_cost',
            'surplus_cost': 'surplus_cost',
            'difference': 'difference',
            'percent': 'percent'
        };

        self.searchQuery = {
            pk: null,
            name: null,
            plate_quantity: null,
            paper_option: null,
            sheet_format: null,
            plate: null,
            quantity_net: null,
            quantity_surplus: null,
            extra_net: null,
            flipped: null,
            realization_date: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        self.rwStatusOptions = rwStatusesConst;

        self.siteOptions = [];
        self.initSiteOption = initSiteOption;

        self.rwExposingData = {
            color: {
                auto_issued: '#9bf3b2',
                manual_issued: '#9bf3b2',
                auto_not_issued: '#f8ac59'
            },
            conditionProp: 'rw_status',
            conditionValue: [
                'auto_issued',
                'manual_issued',
                'auto_not_issued'
            ]
        };

        // Duplicate goes first, so it sits right after the delete button.
        self.extraActions = [{
            class: 'btn btn-primary btn-xs',
            iconClass: 'fa fa-copy',
            title: 'Duplikuj',
            // Duplicating creates a new montage, so it needs the add permission.
            displayCondition: function() {
                return checkModelPermissionsSrvc.isDenied(montagePermissionsConst.add);
            },
            onClick: function(row) {
                return montageSrvc.duplicate(row);
            }
        },{
            class: 'btn btn-primary btn-xs',
            iconClass: 'fa fa-file-pdf-o',
            title: 'Pobierz kartę',
            onClick: function(row) {
                return montageSrvc.getMontageCard(row);
            }
        },{
            class: 'btn btn-primary btn-xs',
            iconClass: 'glyphicon glyphicon-list-alt',
            onClick: toRealization,
            title: 'Do realizacji'
        }];


        self.montageStateOptions = Object.keys(montageStateOptionsConst).map(function(key) {
            return montageStateOptionsConst[key];
        });
        self.filterData = {
            closed: [],
            mounted: [],
            radiated: [],
            printed: [],
            rw_status: [],
            site_pk: null
        };
        self.changeFilter = changeFilter;
        self.isCanDisplaySites = false;

        activate();

        function activate() {
            self.isCanDisplaySites = canDisplaySites();
            self.filterData = filterQuerySrvc.initializeFilterData(self.filterData);
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getSiteOptions(getMontages);

            self.title = self.isArchive() ?
                "Montaże - archiwum" :
                "Montaże";
        }

        function getSelectedToRelization() {
            var selected = [];

            for (var i = 0; i < self.montageRows.length; i++) {
                if (self.montageRows[i][self.checkboxSelectedProp]) {
                    self.montageRows[i][self.checkboxSelectedProp] = false;
                    selected.push(self.montageRows[i]);
                }
            }

            return selected;
        }

        function toRealization(row) {
            $uibModal.open({
                templateUrl: 'app/montage/views/montage-realization/montage-realization.html',
                controller: 'MontageRealizationController',
                controllerAs: 'ctrl',
                size: 'xl',
                windowClass: 'production-cube-realization',
                resolve: {
                    montagePk: function() {
                        return row.pk;
                    }
                }
            }).closed.then(function() {
            });
        }

        function getMontages(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    pk: self.searchQuery.pk,
                    name: self.searchQuery.name,
                    plate_quantity: self.searchQuery.plate_quantity,
                    paper_option: self.searchQuery.paper_option,
                    sheet_format: self.searchQuery.sheet_format,
                    plate: self.searchQuery.plate,
                    quantity_net: self.searchQuery.quantity_net,
                    quantity_surplus: self.searchQuery.quantity_surplus,
                    extra_net: self.searchQuery.extra_net,
                    flipped: searchFilterSrvc.getCheckboxFilterValue(self.searchQuery.flipped),
                    realization_date: searchFilterSrvc.getDateValue(self.searchQuery.realization_date),
                    ordering: self.searchQuery.ordering,

                    closed: self.filterData.closed,
                    mounted: self.filterData.mounted,
                    radiated: self.filterData.radiated,
                    printed: self.filterData.printed,
                    rw_status: self.filterData.rw_status,
                    site_pk: self.filterData.site_pk,
                    is_archive: searchFilterSrvc.getCheckboxFilterValue(self.isArchive())
                };
            }
            return montageDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.montageRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getMontages);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function isArchive() {
            return $state.current.data.isArchive === true;
        }

        function onCreate() {
            $state.go('layout.montage.create');
        }

        function onEdit(row) {
            $state.go('layout.montage.update', { pk: row.pk });
        }

        function onDelete(row) {
            return montageSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", montageMessagesConst.delete);
                lodashService.remove(self.montageRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getMontages();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getMontages();
        }

        function changeFilter() {
            filterQuerySrvc.updateFilterData(self.filterData);
            filterQuerySrvc.setLocationParams();
            return getMontages();
        }

        function initSiteOption() {
            for (var index in self.siteOptions) {
                var optionPk = self.siteOptions[index].pk
                if (optionPk === config.siteId && self.filterData.site_pk === null){
                    self.filterData.site_pk = optionPk;
                }
            }
        }

        function getSiteOptions(callback) {
            if (self.isCanDisplaySites) {
                var siteIds = checkModelPermissionsSrvc.getPermittedSiteIds(
                    montagePermissionsConst.view)
                return siteDataSrvc.getFieldOpts({"ids": siteIds}).$promise.then(
                    function(response) {
                        self.siteOptions = response.results;
                        initSiteOption();
                        callback();
                    });
            } else {
                callback();
            }
        }

        function canDisplaySites() {
            var ids = checkModelPermissionsSrvc.getPermittedSiteIds(montagePermissionsConst.view)
            return ids.length > 1;
        }
    }
})();
